let inject = [
  '$scope',
  'BillfoldService',
  '$state',
  '$rootScope',
  'SharedService',
  '$timeout',
  'ngAuthSettings',
  'CartService',
  'SessionService',
  'NgTableParams',
  '$uibModal',
  '$filter'
];

class BillfoldController{
  constructor ($scope,
               BillfoldService,
               $state,
               $rootScope,
               SharedService,
               $timeout,
               ngAuthSettings,
               CartService,
               SessionService,
               NgTableParams,
               $uibModal,
               $filter) {
    this.$state = $state;
    this.SessionService = SessionService;
    this.ngAuthSettings = ngAuthSettings;
    this.CartService = CartService;
    this.$filter = $filter;
    // this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.NgTableParams = NgTableParams;
    this.BillfoldService = BillfoldService;
    this.$uibModal = $uibModal;
    this.SharedService = SharedService;
    this.billfolds = null;
    this.watchingBillfold = false;
    this.stateBillfold = {};
    this.billfoldSelected = null;
    // ngTable Params
    this.ngTableConfigBillfold = null;
    this.ngTableColsBillfold = null;
    this.state = {};
    this.updatedAt = '';
    this.branches = [];
    // ngTable Params
    this.ngTableConfig = null;
    this.ngTableCols = null;
    this.thirdSelected = null;
    this.branchesSelected = null;
  }

  $onInit(){
    if(!this.shCtrl.globals.currentClient) this.shCtrl.globals.currentClient = {};
    if(!this.shCtrl.globals.currentClient.third) return;
    if(!this.shCtrl.globals.currentClient.third.documentNumber) return;
    this.getBillFolds();
  }

  getBranches(item){
    this.thirdSelected = item;
    this.BillfoldService.getBranchesByThirdId(item.id).then(response => {
      this.branches = response;
    });
  }

  getBillFolds(manual) {
    let documentNumber = '';
    let branchCode = '';
    try{
      if(manual){
        this.billfolds = [];
        documentNumber = this.thirdSelected.nit;
      } else {
        documentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
        if(this.ngAuthSettings.site.config.data.cartera.carteraPorSucursal){
          branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
        }
      }

    }
    catch(e){
      return;
    }

    this.state = {};
    this.state.loading = true;
    if(manual){
      this.BillfoldService.getBillFolds(documentNumber).then(billfolds => {
        if(billfolds === 'null'){
          billfolds = [];
        }
        this.state.loading = false;
        this.state.loaded = true;
        this.billfolds = billfolds;
        this.initNgTable();
        this.updatedAt = this.$filter('date')(new Date(),'yyyy-MM-dd HH:mm:ss');
      }).catch(error => {
        this.state.loading = false;
        this.state.error = true;
      });
    } else {
      this.BillfoldService.getBillFolds(documentNumber, branchCode)
        .then(billfolds => {
          this.state.loading = false;
          this.state.loaded = true;

          if(billfolds === 'null'){
            this.billfolds = [];
          }else{
            this.billfolds = billfolds;
            this.initNgTable();
            this.updatedAt = this.$filter('date')(new Date(),'yyyy-MM-dd HH:mm:ss');
          }

        })
        .catch(error => {
          this.state.loading = false;
          this.state.error = true;
        });
    }

  }

  selectBillfold(billfold) {
    this.watchingBillfold = true;
    let documentNumber = '';
    let branchCode = '';
    let nit = '';
    try {
      nit = this.thirdSelected.nit;
    } catch (e){}
    if(nit){
      documentNumber = this.thirdSelected.nit;
      if(angular.isArray(this.branchesSelected)){
        branchCode = this.branchesSelected;
      } else if(this.branchesSelected.id){
        branchCode = [this.branchesSelected.id];
      } else {
        branchCode = [];
      }
    } else {
      documentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
      if(this.ngAuthSettings.site.config.data.cartera.carteraPorSucursal){
        branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
      }
    }

    if(!documentNumber || !billfold.sucursal) {
      alert('Para realizar la consulta se necesita el numero de documento y el codigo de la sucursal.');
    }
    else {
      this.stateBillfold.loading = true;
      this.branchCode = billfold.sucursal;
      this.BillfoldService.getBillFold(documentNumber, billfold.sucursal).then(billfold => {
        this.stateBillfold.loading = false;
        this.stateBillfold.loaded = true;
        this.billfoldSelected = billfold;
        this.initNgTableBillfold();
        this.updatedAt = this.$filter('date')(new Date(),'yyyy-MM-dd HH:mm:ss');
      }).catch(error => {
        this.stateBillfold.loading = false;
        this.stateBillfold.loaded = true;
        this.stateBillfold.error = true;
      });
    }
  }

  blurBillfold () {
    this.watchingBillfold = false;
    this.billfoldSelected = null;
    this.branchCode = null;
  }

  initNgTableBillfold() {
    /**
     * cupo_credito:                          "1.000000"
     * detalle_fecha_documento:               "2016-06-17"
     * detalle_fecha_vencimiento_documento:   "2016-09-14"
     * detalle_numero_documento:              "FA-205068"
     * detalle_valor_documento:               "50000.0000"
     * empresa:                               "ALERE COLOMBIA S.A."
     * sucursal:                              "01"
     * tercero:                               "ANGEL DIAGNOSTICA S A"
     * tercero_id:                            "805013591"
     * total_cartera:                         "50000.0000"
     * total_sin_vencer:                      "50000.0000"
     * total_vencido:                         "0.0000"
     * total_vencido_1_30:                    "0.0000"
     * total_vencido_31_60:                   "0.0000"
     * total_vencido_61_90:                   "0.0000"
     * total_vencido_91_180:                  "0.0000"
     * total_vencido_mayor_180:               "0.0000"
     */

    this.ngTableColsBillfold = [
      {
        field: "cupo_credito",
        title: "Cupo Crédito",
        sortable: "cupo_credito",
        filter: { "cupo_credito": "text" },
        show: false
      },
      {
        field: "detalle_fecha_documento",
        title: "Fecha Documento",
        sortable: "detalle_fecha_documento",
        filter: { "detalle_fecha_documento": "date" },
        show: true
      },
      {
        field: "detalle_fecha_vencimiento_documento",
        title: "Fecha Vto. Documento",
        sortable: "detalle_fecha_vencimiento_documento",
        filter: { "detalle_fecha_vencimiento_documento": "date" },
        show: true
      },
      {
        field: "detalle_numero_documento",
        title: "Nro. Documento",
        sortable: "detalle_numero_documento",
        filter: { "detalle_numero_documento": "text" },
        show: true
      },
      {
        field: "detalle_valor_documento",
        title: "Vlr. Documento",
        sortable: "detalle_valor_documento",
        filter: { "detalle_valor_documento": "text" },
        show: true
      },
      {
        field: "empresa",
        title: "Empresa",
        sortable: "empresa",
        filter: { "empresa": "text" },
        show: false
      },
      {
        field: "sucursal",
        title: "Sucursal",
        sortable: "sucursal",
        filter: { "sucursal": "text" },
        show: false
      },
      {
        field: "tercero",
        title: "Tercero",
        sortable: "tercero",
        filter: { "tercero": "text" },
        show: false
      },
      {
        field: "tercero_id",
        title: "Tercero Id",
        sortable: "tercero_id",
        filter: { "tercero_id": "text" },
        show: false
      },
      {
        field: "total_cartera",
        title: "Total Cartera",
        sortable: "total_cartera",
        filter: { "total_cartera": "text" },
        show: true
      },
      {
        field: "total_sin_vencer",
        title: "Total Sin Vencer",
        sortable: "total_sin_vencer",
        filter: { "total_sin_vencer": "text" },
        show: true
      },
      {
        field: "total_vencido",
        title: "Total Vencido",
        sortable: "total_vencido",
        filter: { "total_vencido": "text" },
        show: true
      },
      {
        field: "total_vencido_1_30",
        title: "De 1 a 30 días",
        sortable: "total_vencido_1_30",
        filter: { "total_vencido_1_30": "text" },
        show: true
      },
      {
        field: "total_vencido_31_60",
        title: "De 31 a 60 días",
        sortable: "total_vencido_31_60",
        filter: { "total_vencido_31_60": "text" },
        show: true
      },
      {
        field: "total_vencido_61_90",
        title: "De 61 a 90 días",
        sortable: "total_vencido_61_90",
        filter: { "total_vencido_61_90": "text" },
        show: true
      },
      {
        field: "total_vencido_91_180",
        title: "De 91 a 180 días",
        sortable: "total_vencido_91_180",
        filter: { "total_vencido_91_180": "text" },
        show: true
      },
      {
        field: "total_vencido_mayor_180",
        title: "> 180 días",
        sortable: "total_vencido_mayor_180",
        filter: { "total_vencido_mayor_180": "text" },
        show: true
      }
    ];

    let initialParams = {
      count: 20
    };

    let initialSettings = {
      counts: [5, 10, 20],
      paginationMaxBlocks: 8,
      paginationMinBlocks: 2,
      dataset: this.billfoldSelected
    };

    this.ngTableConfigBillfold = new this.NgTableParams(initialParams, initialSettings);
  }

  initNgTable() {

    /**
     * cupo_credito
     * empresa
     * sucursal
     * tercero
     * tercero_id
     * total_cartera
     * total_sin_vencer
     * total_vencido
     * total_vencido_1_30
     * total_vencido_31_60
     * total_vencido_61_90
     * total_vencido_91_180
     * total_vencido_mayor_180
     */

    this.ngTableCols = [
      {
        field: "cupo_credito",
        title: "Cupo Crédito",
        sortable: "cupo_credito",
        filter: { "cupo_credito": "text" },
        show: false
      },
      {
        field: "empresa",
        title: "Empresa",
        sortable: "empresa",
        filter: { "empresa": "text" },
        show: false
      },
      {
        field: "sucursal",
        title: "Sucursal",
        sortable: "sucursal",
        filter: { "sucursal_nombre": "text" },
        show: true
      },
      {
        field: "tercero",
        title: "Tercero",
        sortable: "tercero",
        filter: { "tercero": "text" },
        show: false
      },
      {
        field: "tercero_id",
        title: "Tercero Id",
        sortable: "tercero_id",
        filter: { "tercero_id": "text" },
        show: false
      },
      {
        field: "total_cartera",
        title: "Total Cartera",
        sortable: "total_cartera",
        filter: { "total_cartera": "text" },
        show: true
      },
      {
        field: "total_sin_vencer",
        title: "Total Sin Vencer",
        sortable: "total_sin_vencer",
        filter: { "total_sin_vencer": "text" },
        show: true
      },
      {
        field: "total_vencido",
        title: "Total Vencido",
        sortable: "total_vencido",
        filter: { "total_vencido": "text" },
        show: true
      },
      {
        field: "total_vencido_1_30",
        title: "De 1 a 30 días",
        sortable: "total_vencido_1_30",
        filter: { "total_vencido_1_30": "text" },
        show: true
      },
      {
        field: "total_vencido_31_60",
        title: "De 31 a 60 días",
        sortable: "total_vencido_31_60",
        filter: { "total_vencido_31_60": "text" },
        show: true
      },
      {
        field: "total_vencido_61_90",
        title: "De 61 a 90 días",
        sortable: "total_vencido_61_90",
        filter: { "total_vencido_61_90": "text" },
        show: true
      },
      {
        field: "total_vencido_91_180",
        title: "De 91 a 180 días",
        sortable: "total_vencido_91_180",
        filter: { "total_vencido_91_180": "text" },
        show: true
      },
      {
        field: "total_vencido_mayor_180",
        title: "> 180 días",
        sortable: "total_vencido_mayor_180",
        filter: { "total_vencido_mayor_180": "text" },
        show: true
      },
      {
        field: "actions",
        title: "Detalle",
        show: true
      },
    ];

    let initialParams = {
      count: 20
    };

    let initialSettings = {
      counts: [5, 10, 20],
      paginationMaxBlocks: 8,
      paginationMinBlocks: 2,
      dataset: this.billfolds
    };

    this.ngTableConfig = new this.NgTableParams(initialParams, initialSettings);
  }


}

BillfoldController.$inject = inject;

export default BillfoldController;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/reports/billfold/billfold.controller.js
 **/